import { t } from "../services/utils";
export default {
  GET_ALL: "get_all",
  FOR_TRAINER: "for_trainer",
  FOR_CLIENT: "for_client",
  FOR_GROUP: "for_group",
  FOR_SINGLE_STORY: "for_single_story",
  FOR_STORY_TYPE: "for_story_type"
};